var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"view-layout-moduleheader module"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"type-small-paragraph color-chalky-grey-2"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"actions"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }